import { RouterProvider, createBrowserRouter } from "react-router-dom";
import "./App.css";
import Root from "./page/Root";

import Home from "./page/Home";
import TestList, { loader as testDetailLoader } from "./page/TestList";
import NewInput from "./page/NewInput";
import DescriptDetail from "./page/DescriptDetail";
import Chatbot from "./component/Contents/ChatbotPage";
import Webuilder from "./page/portfolio/Webuilder";
import PorterZone from "./page/portfolio/PorterZone";
import Platform from "./page/portfolio/Platform";
import CardRecommend from "./page/portfolio/CardRecommend";
import MyLife from "./component/Contents/graph/MyLife";
import Chungsol from "./page/portfolio/Chungsol";
import Feedback from "./page/Feedback";
import FeedbackDetail from "./page/FeedbackDetail";
import { QueryClient, QueryClientProvider } from "react-query";
import Join from "./component/Chat/Join";
import Chat from "./component/Chat/Chat";
import Slack from "./page/portfolio/Slack";
import PatternMatching from "./page/portfolio/PatternMatching";
import ShapeReview from "./page/portfolio/ShapeReview";
import RagProject from "./page/portfolio/RagProject";
import MaantanoTicker from "./page/portfolio/MaantanoTicker";
import Lemini from "./page/portfolio/Lemini";
import DailyNews from "./page/portfolio/DailyNews";

const queryClient = new QueryClient();
const router = createBrowserRouter([
  {
    path: "/",
    element: <Root />,
    children: [
      { index: true, element: <Home /> },
      { path: "chatbot", element: <Chatbot /> },
      {
        path: "testlist",
        element: <TestList />,
        children: [
          { index: true, element: <TestList /> },
          {
            path: ":detailId",
            element: <DescriptDetail />,
            id: "test-detail",
            loader: testDetailLoader,
          },
        ],
      },
      {
        path: "feedback",
        element: <Feedback />,
        children: [
          { index: true, element: <Feedback /> },
          {
            path: ":detailId",
            element: <FeedbackDetail />,
            id: "feedback-detail",
            loader: testDetailLoader,
          },
        ],
      },
      { path: "testwrite", element: <NewInput /> },
      { path: "/chat", element: <Chat /> },
      { path: "/join", element: <Join /> },
      { path: "/lifegraph", element: <MyLife /> },
      { path: "/webuilder", element: <Webuilder /> },
      { path: "/slack", element: <Slack /> },
      { path: "/porterzone", element: <PorterZone /> },
      { path: "/platform", element: <Platform /> },
      { path: "/cardrecommend", element: <CardRecommend /> },
      { path: "/chungsol", element: <Chungsol /> },
      { path: "/patternmatching", element: <PatternMatching /> },
      { path: "/shapereview", element: <ShapeReview /> },
      { path: "/ragproject", element: <RagProject /> },
      { path: "/maantanoticker", element: <MaantanoTicker /> },
      { path: "/lemini", element: <Lemini /> },
      { path: "/dailynews", element: <DailyNews /> },
    ],
  },
]);
function App() {
  // RouteChangeTracker();

  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  );
}

export default App;
